module.exports = __webpack_public_path__ + "static/img/ponomariov.d3bbaa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/ponomariov.jpg
// module id = 493
// module chunks = 11